export type NavIconName =
  'home' | 'requests' | 'orders' | 'schedule' | 'profile' | 'discover' | 'notifications';

interface IconProps {
  size?: 20 | 22;
}

function IconFrame({
  children,
  size,
}: IconProps & {
  children: React.ReactNode;
}) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}
    </svg>
  );
}

export function NavIcon({ name, size = 22 }: IconProps & { name: NavIconName }) {
  const common = {
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  };

  return (
    <IconFrame size={size}>
      {name === 'home' && <path d="M3 8.5 10 3l7 5.5V17H3z" {...common} />}
      {name === 'requests' && (
        <>
          <rect x="3" y="4" width="14" height="12" rx="3" {...common} />
          <path d="M3 10h4l1.5 2h3L13 10h4" {...common} />
        </>
      )}
      {name === 'orders' && (
        <>
          <rect x="3" y="4" width="14" height="12" rx="3" {...common} />
          <path d="M6.5 8.5h7M6.5 12h4" {...common} />
        </>
      )}
      {name === 'schedule' && (
        <>
          <rect x="3" y="5" width="14" height="12" rx="3" {...common} />
          <path d="M7 3v3M13 3v3M3 9.5h14" {...common} />
        </>
      )}
      {name === 'profile' && (
        <>
          <circle cx="10" cy="7" r="3" {...common} />
          <path d="M4.5 17c1-3 3-4.5 5.5-4.5s4.5 1.5 5.5 4.5" {...common} />
        </>
      )}
      {name === 'discover' && (
        <>
          <circle cx="9" cy="9" r="5.5" {...common} />
          <path d="m13.5 13.5 3.5 3.5" {...common} />
        </>
      )}
      {name === 'notifications' && (
        <>
          <path d="M5 14.5V8a5 5 0 0 1 10 0v6.5l1.5 1.5h-13z" {...common} />
          <path d="M8 17a2 2 0 0 0 4 0" {...common} />
        </>
      )}
    </IconFrame>
  );
}

export function BackIcon({ size = 20 }: IconProps) {
  return (
    <IconFrame size={size}>
      <path
        d="m12.5 4.5-5.5 5.5 5.5 5.5M7 10h10"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconFrame>
  );
}

export function CloseIcon({ size = 20 }: IconProps) {
  return (
    <IconFrame size={size}>
      <path
        d="m5 5 10 10M15 5 5 15"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </IconFrame>
  );
}
